import React from "react";
import DetailIconWrapper from "@/components/controls/Task/DetailIconWrapper";
import { UserData } from "@/entities/users/types";
import UserAvatar from "@/components/controls/UserAvatar";

interface Props {
  assigneeData: UserData | undefined;
  className?: string;
}

const AssigneeIndicator: React.FC<Props> = ({ assigneeData, className }) => (
  <DetailIconWrapper tooltip={assigneeData?.displayName} className={className}>
    <UserAvatar userData={assigneeData} size="M" />
  </DetailIconWrapper>
);

export default AssigneeIndicator;
